import React from 'react'
import links from 'links'

import { buttonMessages } from 'components/inputs'

import BannerBase from '../BannerBase/BannerBase'

import messages from './messages'
import background from './images/background.jpg'


type SaksCollaborationBannerProps = {
  onClick?: () => void
}

const SaksCollaborationBanner: React.FunctionComponent<SaksCollaborationBannerProps> = (props) => {
  const { onClick } = props

  return (
    <BannerBase
      bgImage={background}
      buttonStyle="gold-30"
      buttonTitle={buttonMessages.learnMore}
      content="Saks collaboration"
      onClick={onClick}
      text={messages.text}
      textColor="white"
      title={messages.title}
      titleColor="white"
      to={links.saks}
    />
  )
}

export default SaksCollaborationBanner
